import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { operationBusyState } from '~/state/atoms/toolsAtoms';

/**
 * Why an operation button is unavailable while the open operation is busy,
 * or undefined while it is not. A button that would replace or close a busy
 * operation reads as disabled, with this reason, rather than ignore a click.
 */
export function useOperationBusyReason(): string | undefined {
    const intl = useIntl();
    const busy = useRecoilValue(operationBusyState);
    return busy
        ? intl.formatMessage({ id: 'toolbar.operation.busyReason' })
        : undefined;
}
